import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface PainelShimmerChromeProps {
  children: React.ReactNode;
  isDarkMode?: boolean;
}

const PainelShimmerChrome: React.FC<PainelShimmerChromeProps> = ({
  children,
  isDarkMode = false,
}) => (
  <SkeletonTheme
    baseColor={isDarkMode ? "#252638" : "#e8eaed"}
    highlightColor={isDarkMode ? "#2e2f46" : "#ffffff"}
    borderRadius={6}
    duration={1.35}
    enableAnimation
  >
    {children}
  </SkeletonTheme>
);

export { Skeleton };
export default PainelShimmerChrome;
